import React, { FC } from 'react';
import { HoverImage, HoverImageColumn } from './styled/HoverBoxImage';
import { NavigationContentLinkTitle } from '../../Links/Links';

interface FallbackSourceProps {
  height: number;
  src: string;
  width: number;
}

interface HoverImageProps {
  alt: string;
  heading: string;
  hoverHref: string;
  image: string;
  imgSources: {
    fallbackSource: FallbackSourceProps;
    responsiveSources: FallbackSourceProps[];
  };
  name: string;
}

const NavigationHoverImage: FC<HoverImageProps> = ({ hoverHref, heading, alt, name, imgSources, image }) => {
  return (
    <HoverImageColumn>
      <NavigationContentLinkTitle color="#F25C5E" href={hoverHref}>
        {heading.toLowerCase()}
      </NavigationContentLinkTitle>
      <a href={hoverHref}>
        <HoverImage
          alt={alt}
          responsivenessConfig={{
            fallbackSize: { width: '435px' },
            imgSources,
          }}
          src={image}
          style={{ height: '321px', width: '480px' }}
          title={name}
        />
      </a>
    </HoverImageColumn>
  );
};

export { NavigationHoverImage };
